const mutations = {
  ISUSERLOGGED (state, payload) {
    state.isUserLogged = payload
  },

  USERID (state, payload) {
    state.user.id = payload
  },

  USERNAME (state, payload) {
    state.user.name = payload
  },

  USEREMAIL (state, payload) {
    state.user.email = payload
  },

  USERTOKEN (state, payload) {
    state.user.token = payload
  },

  PROFILE (state, payload) {
    state.profile = payload
  },

  CURRENTPROFILE (state, payload) {
    state.currentProfile = payload
  },

  REDIRECTO (state, payload) {
    state.redirectTo = payload
  },

  RQRLISTINGFILTERS (state, payload) {
    state.RQRlistingFilters = payload
  },

  REVIEWSLISTINGFILTERS (state, payload) {
    state.reviewslistingFilters = payload
  },

  ARRLISTINGFILTERS (state, payload) {
    state.ARRlistingFilters = payload
  },
}

export default mutations
